import InsuranceManage from "../components/InsuranceManage";
import { useState, useEffect } from "react";
import {
  apiRoute,
  requestSecureGet,
  requestSecurePatch,
  requestSecurePost,
} from "@libs/api";
import useToken from "@hooks/useToken";
import { useRecoilValue } from "recoil";
import { getTelecoms } from "@stories/Selector";
import { InsuranceTypes } from "@typedef/components/Telecom/Insurance/insurance.types";

type Props = {
  idx?: number;
  close: () => void;
  reload: () => void;
};

// 통신사관리 > 보험관리 관리 모달
const InsuranceManageContainer = ({ idx, close, reload }: Props) => {
  const { getToken } = useToken();
  const [inputs, setInputs] = useState<Partial<InsuranceTypes>>({});
  // 통신사 리스트 조회
  const telecoms = useRecoilValue(getTelecoms(getToken()!));

  // onChange (input)
  const onChangeInputs = (e: { target: HTMLInputElement }) => {
    const { name, value } = e.target;
    setInputs((inputs) => ({
      ...inputs,
      [name]: value,
    }));
  };

  // onChange (select)
  const onChangeSelect = <T extends {}>(name: string, selected: T) => {
    setInputs((inputs) => ({
      ...inputs,
      [name]: selected,
    }));
  };

  // 등록
  const insert = async () => {
    const { config } = await requestSecurePost(
      apiRoute.telecom.insurance.postInsurance,
      {},
      inputs,
      getToken()!
    );
    if (config.status >= 200 && config.status < 400) {
      alert("성공적으로 등록이 완료되었습니다.");
      close();
      reload();
    }
  };

  // 수정
  const update = async () => {
    const { config } = await requestSecurePatch(
      apiRoute.telecom.insurance.patchInsurance,
      {},
      { ...inputs, insuranceId: idx },
      getToken()!
    );
    if (config.status >= 200 && config.status < 400) {
      alert("성공적으로 수정이 완료되었습니다.");
      close();
      reload();
    }
  };

  const getCheckedData = async () => {
    const { config, data } = await requestSecureGet<{
      insurance: InsuranceTypes;
    }>(apiRoute.telecom.insurance.getInsurance + idx, {}, getToken()!);
    if (config.status >= 200 && config.status < 400) {
      setInputs(data.insurance);
    }
  };

  useEffect(() => {
    if (idx) {
      getCheckedData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx]);

  return (
    <InsuranceManage
      type={idx ? "수정" : "등록"}
      inputs={inputs}
      onChangeInputs={onChangeInputs}
      onChangeSelect={onChangeSelect}
      telecoms={telecoms}
      save={idx ? update : insert}
    />
  );
};

export default InsuranceManageContainer;
